export enum DocumentTypeIdentifier {
  'SO' = 'Confirmation',
  'CASE' = 'ReturnConfirmation',
  'SCR' = 'CreditNote',
  'SIN' = 'Invoice',
  'PA' = 'DeliveryNote',
}
